// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.feedlistingmanagement.RentalManagerUserFeedListingManagementWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion,
  RentalManagerUserFeedListingManagementWebApiHandler_getListingSources,
  RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  CreateManualVersionResponseWebDto,
  GetListingSourcesResponseWebDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface CreateManualVersionParams {
  listingAlias: ListingAlias;
}
interface GetListingSourcesParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Args {
  getParams: CreateManualVersionParams;
}

export type RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Options = UseMutationOptions<
  CreateManualVersionResponseWebDto,
  unknown,
  RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Args
>;

/**
 * Create manual version of the listing
 */
export const useRentalManagerUserFeedListingManagementWebApiHandler_createManualVersion = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion_Args) =>
      RentalManagerUserFeedListingManagementWebApiHandler_createManualVersion(args.getParams, httpClient),
  });
};

export type RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_Options = UseQueryOptions<
  GetListingSourcesResponseWebDto,
  unknown,
  GetListingSourcesResponseWebDto,
  readonly [string, GetListingSourcesParams]
>;

const RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_GetKey = (
  getParams: GetListingSourcesParams,
) => [RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_Path, getParams] as const;

export const RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_queryOptions = (
  getParams: GetListingSourcesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_GetKey(getParams),
    queryFn: () => RentalManagerUserFeedListingManagementWebApiHandler_getListingSources(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listing sources of a listing
 */
export const useRentalManagerUserFeedListingManagementWebApiHandler_getListingSources = (
  getParams: GetListingSourcesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFeedListingManagementWebApiHandler_getListingSources.getKey =
  RentalManagerUserFeedListingManagementWebApiHandler_getListingSources_GetKey;
